(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3380],{

/***/ 24391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ BulletedList; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var BulletedList = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "BulletedList",
  componentId: "sc-ep09my-0"
})(["font-size:16px;line-height:1.3;list-style:", ";margin-left:24px;display:flex;flex-direction:column;gap:21px;> li::marker{color:", ";}@media screen and (max-width:1047px){font-size:15px;line-height:1.6;gap:12px;}"], function (_ref) {
  var listStyle = _ref.listStyle;
  return listStyle !== null && listStyle !== void 0 ? listStyle : 'disc';
}, function (_ref2) {
  var listStyle = _ref2.listStyle;
  return listStyle === 'decimal' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle : _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.grey */ .r.colors.grey;
});

/***/ }),

/***/ 43658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ IssuePage; }
});

// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/enlayout.tsx + 7 modules
var enlayout = __webpack_require__(34591);
// EXTERNAL MODULE: ./src/components/enlayouts/Head/index.tsx
var Head = __webpack_require__(32056);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/index.tsx + 3 modules
var Ir = __webpack_require__(82319);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/BulletedList.tsx
var BulletedList = __webpack_require__(24391);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/Heading.tsx
var Heading = __webpack_require__(3319);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/Paragraph.tsx
var Paragraph = __webpack_require__(81507);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/enpages/Ir/Manage/Issue/index.tsx











var IssuePage = function IssuePage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Ir/* Layout */.A, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      color: "normal",
      enTitleText: "Issues",
      subTitleText: ""
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 120
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "The Group aims to expand the store network through enhancing the attractiveness and profitability of stores through strengthening food offerings with a focus on fresh food, as well as store renovations in the retail distribution business. Additionally, in the Retail AI business, the Group strives to improve the value proposition to retail companies, food and consumer goods manufacturers, and vendors through the development of new products and solutions, as well as the enhancement of existing products. Although the Group continues to operate in a challenging business environment, including rising consumer demand for savings amid higher prices driven by increases in energy costs and personnel expenses, we will continue to build a business foundation for sustainable growth over the medium to long term."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "Through the full acquisition of SEIYU on July 1, 2025, the Group significantly expanded its business scale and operating base. At the same time, key management challenges include integrating the resources of the two companies, realizing group synergies at an early stage, improving the profitability of existing businesses, maintaining financial soundness, and establishing a management structure capable of supporting the Group\u2019s expanded scale."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "The Group formulated its Medium-Term Management Plan in February 2026, positioning the three-year period from FY6/2027 through FY6/2029 as \u201CThree Years to Build the Foundation for Retail Transformation\u201D toward realizing its long-term vision."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "The Group has set quantitative targets for FY6/2029 of 1.6 trillion yen in net sales, 100.0 billion yen in EBITDA, and 64.0 billion yen in operating profit. By strengthening the cash-generating capabilities centered on synergies, we will improve financial soundness and build a strong foundation for significant growth from FY6/2030 onward."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "To achieve these targets, the Group has identified the following five key strategies and will prioritize their execution."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* BHeading */.Zg, {
        children: "\u2460 Maximizing Group Synergies Through PMI"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "To execute the integration process with SEIYU swiftly and steadily to improve profitability and productivity across the Group."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BulletedList/* BulletedList */.h, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Optimization of Procurement and Sourcing: Standardize procurement terms and consolidate suppliers to generate gross margin improvement."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Strengthening PB and Advancing Category Management: Reorganize, cross-sell, and jointly develop the two companies\u2019 brands, including \u201CKohaku Hompo\u201D and \u201CMinasama no Osumitsuki,\u201D with the aim of increasing the Group-wide PB sales mix to 25%. At the same time, we will improve shelf productivity through AI and data analytics and integrate the operations of Process Centers and Central Kitchens."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Promoting System Integration: Integrate and consolidate SEIYU\u2019s core systems into TRIAL\u2019s systems to reduce development, operation, and maintenance costs."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* BHeading */.Zg, {
        children: "\u2461 Enhancing TRIAL\u2019s Profitability and Driving Growth"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "Drive sustainable growth by refining the high-profitability business model and strategically expanding the store network."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BulletedList/* BulletedList */.h, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Accelerating Store Openings: By leveraging the proprietary trade area analysis tool, \u201CRetail Map,\u201D we will open 35 Supercenters over three years based on highly accurate site selection. We will also accelerate the multi-store rollout of the small-format \u201CTRIAL GO,\u201D targeting 100 stores over three years."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Sustaining Same-Store Sales Growth: Actively renovate existing stores, with a cumulative total of 45 stores over three years, while strengthening the food and PB offerings, targeting an 8% sales mix for ready meals."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Enhancing the Shopping Experience Through Digital Technologies: In addition to refining the pricing, we will leverage Skip Cart, in-store signage, membership app, and other digital tools to deliver personalized approaches based on individual customer needs, achieving both price-focused and value-focused offerings."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* BHeading */.Zg, {
        children: "\u2462 Transforming SEIYU Stores and Expanding Customer Support"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "Undertake fundamental store reforms at SEIYU to drive top-line growth and earn stronger customer traffic."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BulletedList/* BulletedList */.h, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Rolling Out Successful Merchandising and Renovation Models: Roll out the know-how developed at successful model stores across the entire network to strengthen existing stores, while strategically renovating 60 Supermarkets."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Expanding the New \u201CTRIAL SEIYU\u201D Format: Convert 30 large stores (Hypermarkets) into \u201CTRIAL SEIYU\u201D format, a successful fresh-food-focused store model with price competitiveness as a key strength."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Reducing the SG&A Ratio: While proactive price investments will temporarily lower the gross profit margin, we will build a structure for significant SG&A ratio reductions and profit growth through fixed-cost absorption from higher sales and the benefits of system integration and other initiatives."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* BHeading */.Zg, {
        children: "\u2463 Transitioning the DX Strategy to the Monetization Phase"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "Move the DX foundation built to date into full-scale monetization and support growth across the Group."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BulletedList/* BulletedList */.h, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Group-wide Utilization of Data and AI: Alongside the integration of core systems, promote the use of data and AI across the entire Group, including SEIYU."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Building New Business Platforms: Make concrete progress in building the business platforms for retail media and e-commerce and establish capabilities that will contribute to future sales and profit growth."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* BHeading */.Zg, {
        children: "\u2464 Strengthening the Management Foundation to Support Sustainable Growth"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "Achieve an optimal balance between growth investments and financial soundness to maximize corporate value."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BulletedList/* BulletedList */.h, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Promoting Sustainability Management: Guided by the Group\u2019s purpose, \u201CEnrich every aspect of people's lives through all we do.\u201D contributes to the development and growth of both the Group and society as a whole. Centered on the operation of physical stores, pursue a sustainable society through the advancement of Retail DX and collaboration with diverse partners."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Appropriate Cash Allocation: Using cash generated from operating activities as the primary source of funding, prioritize the allocation of 130.0 billion yen to growth investments, including new store openings, format conversions, and store renovations."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Restoring Financial Soundness: Execute disciplined debt repayment following the full acquisition of SEIYU, targeting 115.0 billion yen in debt repayment over three years, with the aim of achieving a Net Debt/EBITDA ratio of 3.0x or below and an equity ratio of 20% or higher by FY6/2029."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Human Capital, Partnerships, and Shareholder Returns: In addition to strengthening human capital and building external partnerships that contribute to transformation across the industry, we will consider strategic M&A opportunities. For shareholders, we will provide stable and sustainable returns based on our progressive dividend policy."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "The Group will pursue these key strategies as one team and establish and roll out successful models for next-generation smart stores, with the aim of making a significant leap toward becoming a world-leading \u201CRetail Platformer.\u201D"
      })]
    })]
  });
};

IssuePage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'Home',
    path: '/en/'
  }, {
    name: 'Investor Relations',
    path: '/en/ir/'
  }, {
    name: 'Management Policy',
    path: '/en/ir/manage'
  }, {
    name: 'Issues',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "Issues",
      description: "Business issues that should be addressed on a priority basis.",
      ogp: {
        url: 'en/ir/manage/issue/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(enlayout/* TitleLayout */.$0, {
      title: "Investor Relations",
      subTitle: "",
      breadCrumbs: breadCrumbs,
      children: page
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/en/ir/manage/issue.tsx


/***/ }),

/***/ 30852:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ir/manage/issue",
      function () {
        return __webpack_require__(43658);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,4591,4123,9774,2888,179], function() { return __webpack_exec__(30852); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);